import { useIsFocused, useNavigation, useRoute } from '@react-navigation/native'
import { useShowHamburger } from 'utils/helper-device'
import _ from 'lodash'
import FetchReports from 'utils/fetch/FetchReports'
import React, { useEffect, useState } from 'react'
import { constantsActive } from 'utils/constants/constants'
import GraphqlBuilder, { graphqlOptions } from 'utils/request/graphql/builder'
import { FormFieldsConstants, FormStatus } from 'utils/constants/form-constants'
import { AppRoutes } from 'navigations/app-routes'
import i18n from 'utils/i18n'
import LoadingComponent from 'components/atoms/Loading'
import HelperString from 'utils/helper-string'
import Form from 'components/molecules/Form'
import ThemedSafeAreaComponentTop from 'components/atoms/ThemedSafeAreaTop'
import ThemedLayout from 'components/atoms/ThemedLayout'
import ThemedBlock from 'components/atoms/ThemedBlock'
import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import MutationManagementReport from 'graphql/mutations/management/MutationManagementReport'

const ManagementReportsScheduleEditScene = () => {
	
	const showHamburger = useShowHamburger();
	const route = useRoute();
	const navigation = useNavigation();
	const isFocused = useIsFocused();
	
	const _buildings = useSelector( state => {
		return state.data[dataConstants.BUILDINGS];
	} )
	const _timeslotKinds = useSelector( state => {
		return state.data[dataConstants.TIMESLOT_KINDS];
	} )
	const _languages = useSelector( state => {
		return state.data[dataConstants.LANGUAGES];
	} )
	
	const defaultValues = {
		active: constantsActive.YES
	}
	
	const [ loading, setLoading ] = useState( true )
	const [ report, setReport ] = useState( {} )
	const [ updatedValues, setUpdatedValues ] = useState( defaultValues )
	
	const guid = _.get( route.params, 'guid', null );
	
	const fetch = () => {
		// WHen not creating, fetch the exception
		if( guid !== null ) {
			FetchReports.fetch({
				guid: guid,
				callbackSuccess: result => {
					result.language_guid = _.get( result, ['language', 'guid'], null )
					result.building_guid = _.get( result, ['building', 'guid'], null )
					result.timeslot_kind_guid = _.get( result, ['timeslot_kind', 'guid'], null )
					
					setReport( result )
					setUpdatedValues( result )
					setLoading( false )
				}
			})
			return;
		}
		
		setLoading( false )
	}
	
	const onChange = ( values ) => {
		setUpdatedValues({
			...updatedValues,
			...values
		})
	}
	
	const onSubmit = (values, { callback } = {} ) => {
		new GraphqlBuilder( { [ graphqlOptions.processVariables ]: false })
			.addQuery( 'mutation', MutationManagementReport, values )
			.setResultPath( ['mutation', 'report'], {} )
			.setOnStart( () => {
				callback( FormStatus.LOADING )
			})
			.setOnSuccess( ( result ) => {
				callback( FormStatus.SUCCESS );
				
				if( guid !== result.guid ) {
					navigation.replace( AppRoutes.MANAGEMENT_REPORTS_SCHEDULE_EDIT, {
						guid: result.guid,
					});
				}else{
					fetch();
				}
			})
			.setOnError( ( result ) => {
				callback( FormStatus.ERROR )
			})
			.execute()
	}
	
	useEffect( () => {
		return fetch();
	}, [ guid, isFocused ] )
	
	const formFields = [
		{
			name: 'type',
			label: i18n.t('management:form.kind.title'),
			type: FormFieldsConstants.SELECT,
			options: [
				{
					value: 'bookings',
					label: i18n.t( 'management:generic.timeslot.kind.booking')
				},
				{
					value: 'lunches',
					label: i18n.t( 'management:generic.timeslot.kind.lunch')
				},
				{
					value: 'parkings',
					label: i18n.t( 'management:generic.timeslot.kind.transport')
				},
			]
		},
		{
			name: 'email',
			label: i18n.t('management:form.email.title'),
			type: FormFieldsConstants.TEXT,
		},
		{
			name: 'time',
			label: i18n.t('management:form.time.title'),
			type: FormFieldsConstants.TIME,
		},
		{
			name: 'for_date',
			label: i18n.t('management:form.for_date.title'),
			type: FormFieldsConstants.SELECT,
			options: [
				{
					value: null,
					label: i18n.t('management:generic.today')
				},
				{
					value: '+1 day',
					label: '+1 day'
				},
				{
					value: '+2 days',
					label: '+2 days'
				},
				{
					value: '-1 day',
					label: '-1 day'
				},
				{
					value: '-2 days',
					label: '-2 days'
				},
			]
		},
		{
			name: 'language_guid',
			label: i18n.t('management:form.language.title'),
			type: FormFieldsConstants.SELECT,
			options: _.map( _languages, o => {
				return {
					value: o.guid,
					label: o.name
				}
			})
		},
		{
			name: 'building_guid',
			label: i18n.t('management:form.building.title'),
			type: FormFieldsConstants.SELECT,
			options:[
				{
					value: '',
					label: ' '
				},
				..._.map( _buildings, o => {
					return {
						value: o.guid,
						label: o.name
					}
				})
			]
		},
		{
			name: 'active',
			label: i18n.t('management:form.active.title'),
			type: FormFieldsConstants.SELECT_ACTIVE
		},
	]
	
	let content = <LoadingComponent />
	if( !loading ) {
		content = [
			<ThemedBlock
				key={ HelperString.hash( 'report', guid ) }
				shadow
				mediumPadding>
				
				<Form
					values={ updatedValues }
					fields={ formFields }
					onChange={ onChange }
					onSubmit={ onSubmit }
					//disabled={ !HelperManagementRights.hasEditRight( managementRightsConstants.VIEW.BOOKINGS_REPORTS ) }
					forceSaveButton={ true }
				/>
			</ThemedBlock>
		];
	}
	
	return (
		<ThemedSafeAreaComponentTop
			top={ false }>
			
			<ThemedLayout
				title={ i18n.t( 'management:pages.reports.schedule.title') }
				topNavigation={true}
				topNavigationProps={{
					showHamburgerDrawer: showHamburger
				}}
				showBackButton={ true }>
				
				{ content }
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	)
}

export default ManagementReportsScheduleEditScene
